<script setup>

const props = defineProps({
  cellInfo: { type: Object, required: true },
  readonly: Boolean
})

const emit = defineEmits(['blur'])

const topPart = (v) => v ? v.substring(0, 2).toUpperCase() : ''
const bottomPart = (v) => v ? v.substring(2) : ''

const update = (part, inputVal) => {
  const current = props.cellInfo.value || ''
  const top = current.substring(0, 2)
  const bottom = current.substring(2)
  const next = part === 'top'
    ? (inputVal.toUpperCase() + bottom).trim()
    : (top + inputVal.toUpperCase()).trim()
  props.cellInfo.setValue(next)
}

const clearInfoBikePlate = () => {
  props.cellInfo.setValue('')
}

const onBlur = () => {
  if (props.readonly) return
  emit('blur')
}

defineExpose({
  clearInfoBikePlate
})
</script>

<template>
  <div class="plate-moto-wrapper">
    <div class="plate-moto-outer">
      <div class="plate-moto-top-band">
        <div class="plate-moto-eu-left">
          <span class="plate-moto-country">I</span>
        </div>
        <input
          class="plate-moto-input plate-moto-input--top"
          :value="topPart(cellInfo.value)"
          :readonly="readonly"
          :tabindex="readonly ? -1 : 0"
          maxlength="2"
          placeholder="AA"
          @input="e => update('top', e.target.value)"
          @blur="onBlur"
        >
        <div class="plate-moto-eu-right">
          <div class="plate-moto-circle" />
        </div>
      </div>
      <div class="plate-moto-bottom">
        <input
          class="plate-moto-input plate-moto-input--bottom"
          :value="bottomPart(cellInfo.value)"
          :readonly="readonly"
          :tabindex="readonly ? -1 : 0"
          maxlength="5"
          placeholder="12345"
          @input="e => update('bottom', e.target.value)"
          @blur="onBlur"
        >
      </div>
    </div>
  </div>
</template>
<style scoped>

.plate-moto-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.plate-moto-outer {
  border: 4px solid #111;
  border-radius: 8px;
  overflow: hidden;
  width: 140px;
  background: #f5f5e8;
  box-shadow: 2px 2px 6px rgba(0,0,0,0.4);
}

.plate-moto-top-band {
  display: flex;
  align-items: center;
  background: #003399;
  height: 42px;
  padding: 0 4px;
  gap: 4px;
}

.plate-moto-eu-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #FFD700;
  font-size: 5px;
  line-height: 1;
  min-width: 20px;
}

.plate-moto-country {
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  margin: 1px 0;
}

.plate-moto-stars {
  letter-spacing: -1px;
}

.plate-moto-eu-right {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
}

.plate-moto-circle {
  width: 18px;
  height: 18px;
  border: 2px solid #FFD700;
  border-radius: 50%;
}

.plate-moto-input--top {
  background: #fff;
  flex: 1;
  font-size: 20px;
  letter-spacing: 4px;
  text-align: center;
  height: 32px;
  font-weight: bold;
  font-family: 'Arial Black', sans-serif;
}

.plate-moto-bottom {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  padding: 4px;
}

.plate-moto-input--bottom {
  background: transparent;
  font-size: 28px;
  letter-spacing: 2px;
  text-align: center;
  font-weight: bold;
  font-family: 'Arial Black', sans-serif;
  width: 100%;
}

.plate-moto-input {
  border: none;
  outline: none;
  text-transform: uppercase;
  color: #111;
  padding: 0;
  width: 100%;
}

.plate-moto-input::placeholder {
  color: #bbb;
}
</style>
